<template>
  <div class="flex justify-center rounded-lg mx-2 mt-2 md:mt-6">
    <div class="md:w-5/12">
      <div
        v-show="errorNotSubscribed"
        class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
        role="alert"
        dir="rtl"
      >
        <span class="block sm:inline text-center">
          {{ messageNotSuscribed }}
          <router-link to="/subscribe/headerinerchment" class="text-blue-600">
            إشترك الان</router-link
          ></span
        >
        <span
          class="absolute top-0 bottom-0 left-0 px-4 py-3 cursor-pointer"
          @click="close"
        >
          <svg
            class="fill-current h-6 w-6 text-red-500"
            role="button"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <title>Close</title>
            <path
              d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"
            />
          </svg>
        </span>
      </div>
      <div
        class="container mx-auto px-4 p-1 bg-sub shadow-md drop-shadow-2xl lg:p-2 rounded-md place-items-center"
      >
        <auth-carsouel />
        <div class="">
          <h5
            dir="rtl"
            class="my-3 text-md text-lg text-white font-bold font-Tajawal text-center"
          >
            قم بالدخول واستمتع بمشاهدة البرامج والقنوات بلا حدود
          </h5>
          <!-- <div  class="border border-b-2 border-pink-500  mx-2 mx-auto mt-1 w-36"></div> -->

          <div class="m-3 relative md:w-96 mx-auto" dir="rtl">
            <label for="mobile" class="text-white"> رقم الهاتف</label>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 absolute right-3 top-7 rotate-230"
              fill="none"
              viewBox="0 0 24 24"
              stroke="white"
              stroke-width="1"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
              />
            </svg>

            <input
              type="text"
              class="bg-gray-900 border border-color focus:ring-pink-500 focus:border-pink-500 text-gray-900 text-sm rounded-sm w-full"
              v-model="phone"
              placeholder="09xxxxxxxx"
              required
            />
          </div>

          <div class="flex justify-center my-6">
            <button
              type="submit"
              class="text-white focus:ring-0 focus:outline-none focus:ring-pink-300 rounded-lg text-md w-full sm:w-auto px-5 py-2.5 text-center btn-color cursor-pointer w-btn absloute z-20"
              @click="login"
              :class="loading ? 'animate animate-pulse' : ''"
            >
              !دخول الان
            </button>
          </div>
          <div class="text-white relative" dir="rtl">
            <p class="text-center text-gray-200 absloute z-40">
              أو قم
              <router-link
                to="/subscribe/headerinerchment"
                class="text-green-600 absloute z-40"
                >بالإشتراك</router-link
              >
            </p>

            <p
              class="text-center font-small m-2 font-Tajawal mt-2 hidden"
              style="font-size: 11px; line-height: 15px"
            >
              قيمة الاشتراك اليومي لكل المقاطع والبرامج 120 جنيه فقط شاملة الضريبة تجدد
              تلقائيا عبر شبكة سوداني
            </p>
          </div>
          <!-- hello -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mtnValidate } from "@/utils/mtnValidation";
import AuthCarsouel from "@/components/shared/AuthCarsouel.vue";

import { useAuthStore } from "@/stores/auth";
import { mapActions } from "pinia";
import { useToast } from "vue-toastification";

export default {
  components: {
    AuthCarsouel,
  },
  data() {
    return {
      phone: "",
      error: false,
      errorNotSubscribed: false,
      message: "رقم الهاتف غير صحيح",
      messageNotSuscribed: "أنت غير مشترك  قم بالإشتراك",
      toast: useToast(),
      loading: false,
    };
  },
  methods: {
    ...mapActions(useAuthStore, ["checkSubescriptionStatus"]),
    async login() {
      this.loading = true;

    const result = mtnValidate(this.phone);

if (!result.valid) {
    console.log(result.message);
    this.toast.error(result.message);
    this.loading = false;
    return;
}

      // subscribe end point for getting the url
      if (result.valid) {
        const data = {
          phone: result.phone,
        };
        await this.checkSubescriptionStatus(data).then((response) => {
          this.redirect(response);
        });
      }
    }, //end of subscrbtion method

    close() {
      return (this.error = false), (this.errorNotSubscribed = false);
    },
    redirect(response) {
      console.log(response.data);
      if (response.data.success) {
        this.toast.success("تم تسجيل الدخول");
        this.$router.push({ name: "home" });
      } else {
        this.toast.error("ليس لديك إشتراك قم بالإشتراك");

        this.$router.push({ name: "subscribe.header" });
      }
      this.isLaoding = false;
    },
  },
};
</script>

<style scoped>
.width-height {
  width: 900px;
  height: auto;
}
.xxsm {
  width: 255px;
}
.w-btn {
  width: 290px;
  align-self: right;
}

.btn-color {
  background-color: #9d2890;
}

.bg-sub {
  background-color: #181b30;
}

input {
  text-align: center;
  outline: none;
  padding-left: 5px;
  color: aliceblue;
}

::-webkit-input-placeholder {
  text-align: center;
}

:-moz-placeholder {
  text-align: center;
}
.font-small {
  font-size: 16px;
}
</style>
